import { combineReducers } from "redux";
import appStatusReducer from "./appStatus";
import customerReducer from "./customer";
import customerProfileReducer from "./customerProfile";
import customerRecentAppointmentReducer from "./customerRecentAppointment";
import customerNotesReducer from "./customerNotes";
import languageProviderReducer from "./languageProvider";
import menuReducer from "./menu";
import appointmentStepReducer from "./appointmentStep";
import advancedAppointmentStepReducer from "./advancedAppointmentStep";
import bookingReducer from "./booking";
import appointmentCheckoutReducer from "./appointmentCheckoutStep";
import waitlistStepReducer from "./waitlist";
import globalErrorReducer from "./globalError";
import globalSuccessReducer from "./globalSuccess";

import { LOCATION_CHANGE } from "react-router-redux";

export default function createReducer(injectedReducers) {
  let appReducer = combineReducers({
    appStatusReducer: appStatusReducer,
    bookingReducer: bookingReducer,
    advancedAppointmentStepReducer: advancedAppointmentStepReducer,
    customerReducer: customerReducer,
    customerProfileReducer: customerProfileReducer,
    customerRecentAppointmentsReducer: customerRecentAppointmentReducer,
    customerNotesReducer: customerNotesReducer,
    languageProviderReducer: languageProviderReducer,
    menuReducer: menuReducer,
    appointmentStepReducer: appointmentStepReducer,
    appointmentCheckoutReducer: appointmentCheckoutReducer,
    waitlistStepReducer: waitlistStepReducer,
    globalErrorReducer: globalErrorReducer,
    globalSuccessReducer: globalSuccessReducer,
    ...injectedReducers
  });

  const rootReducer = (state, action) => {
    if (action.type === "CLOSED_FORM" || action.type === "OPENED_FORM") {
      //DES-730
      state = undefined;
    }
    return appReducer(state, action);
  };

  return rootReducer;
}
